import styled from '@emotion/styled';
import theme from 'src/theme';
import { Button } from '@mui/material';

const font = (fontSize: number, lineHeight: number): React.CSSProperties => {
    return {
        fontFamily: '"Inter",sans-serif',
        fontSize,
        lineHeight
    };
};

export const S: { [key: string]: React.CSSProperties } = {
    statusText: {
        ...font(12, 12),
        color: theme.color.white50,
        marginRight: '12px'
    },
    statusChip: {
        backgroundColor: theme.color.lightGreen,
        color: theme.color.green,
        ...font(12, 12)
    },
    sinceText: {
        ...font(12, 12),
        color: theme.color.white30,
        marginLeft: '12px'
    }
};

export const PriorityWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 8px;
    padding-left: 8px;
`;

export const PriorityLabelWithIcon = styled.label`
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: ${theme.color.white50};
`;

export const InfoIconButton = styled.button`
    padding: 0;
    background: none;
    border: none;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    height: 16px;

    &:hover {
        background-color: transparent;
    }

    svg {
        width: 16px;
        height: 16px;
    }
`;

export const LlmInfoWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 8px;
    padding-left: 8px;
`;

export const LlmInfoLabel = styled.label`
    font-size: 12px;
    color: ${theme.color.white50};
`;

export const ViewSessionsButton = styled(Button)`
    text-transform: none;
    color: ${theme.color.white};
    border-color: ${theme.color.white50};
    font-size: 11px;
    padding: 2px 8px;
    min-width: 0;
    height: 24px;
`;
